import { DEFAULT_OG_IMAGE, SITE_URL } from "@/lib/constants/site-url"
import { termsContent } from "@/lib/data/legal-pages"
import { LegalPage } from "@/pages/legal"
import { createFileRoute } from "@tanstack/react-router"

const OG_IMAGE = DEFAULT_OG_IMAGE

export const Route = createFileRoute("/$countryCode/terms-and-conditions")({
  head: () => {
    const title = "Terms and Conditions | +Bake Cafe"
    const description =
      "Read +Bake Cafe's Terms and Conditions for website use, pickup orders, availability, cancellations, allergens, and third-party platforms."
    const canonical = `${SITE_URL}/terms-and-conditions`

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        {
          "@type": "ListItem",
          position: 2,
          name: "Terms and Conditions",
          item: canonical,
        },
      ],
    }

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:site_name", content: "+Bake Cafe" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) }],
    }
  },
  component: () => <LegalPage {...termsContent} />,
})
